var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
export class CesopCountries {
  /**
   * Creates an instance of CesopCountries.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CesopCountries
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetAvailableCountriessRq_ _getAvailableCountriessRq
   * @returns Promise<GetAvailableCountriessRq_>
   * @memberof CesopCountries
   */
  getAvailableCountriess(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Countries", "GET", "application/json; charset=UTF-8", "application/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
